module.exports = __webpack_public_path__ + "img/no-data.d113d8d0.png";